import { render, staticRenderFns } from "./MyTagInput.vue?vue&type=template&id=6e2993f6&scoped=true&"
import script from "./MyTagInput.vue?vue&type=script&lang=js&"
export * from "./MyTagInput.vue?vue&type=script&lang=js&"
import style0 from "./MyTagInput.vue?vue&type=style&index=0&id=6e2993f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2993f6",
  null
  
)

export default component.exports